import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup, Row } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";

const ClinicVisitScanSubtitleOption = ({ option, referesh, setReferesh }) => {
  const [optionLabel, setOptionLabel] = useState(option.label);
  const [isHide, setIsHide] = useState(option.isHide);

  const hideOption = () => {
    if (
      window.confirm(`You will delete ${optionLabel} option. Are you sure?`)
    ) {
      setIsHide(!isHide);
    }
  };
  useEffect(() => {
    option.label = optionLabel;
    option.isHide = isHide;
    setReferesh(!referesh);
  }, [optionLabel, isHide]);

  return (
    <Row>
      {!isHide && (
        <InputGroup className="w-100 my-1">
          <Form.Control
            placeholder="Type option here, like: fever"
            type="text"
            onChange={(e) => setOptionLabel(e.target.value)}
            value={optionLabel}
            isValid={optionLabel}
            isInvalid={!optionLabel}
          ></Form.Control>

          <Button className="btn-danger" onClick={() => hideOption()}>
            <FaTrash />
          </Button>
        </InputGroup>
      )}
    </Row>
  );
};

export default ClinicVisitScanSubtitleOption;
